import React from "react";
import "./Footer.css";  

const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2024-2025. Designed and Developed by Casilyn Zirui Soong.</p>
        </footer>
    );
};

export default Footer;